import React, {useEffect} from 'react'



export function Button({value, onClick,short=false, active=false,extraClass="", background,...props}){
    const style ={}
    if(background) style.background = background
    return (
        <button
            style={style}
            onClick={onClick ?? null}
            className={`button  ${extraClass} ${short ? "buttonShort" : ""} ${active ? "button-active" : ""}`}>
            {value || ""}
        </button>
    )
}



export function Input({value, onClick, onChange=null,name="", type="text",placeholder="",...props}){
    const style = {}
    return (
        <div className="uiInputContainer">
            <input className="input" onChange={onChange} name={name} type={type} placeholder={placeholder} value={value?? null}/>
        </div>
        
    )
}



export function Panel({title, panelClass="", rowClass="", ...props}){
    const pc = `${panelClass} uiPanel`
    const rc = `${rowClass} uiRow`
    return (
        <div className={pc}>
            {title && <div className="title">{title}</div>}
            <div className={rc}>
                {props.children}
            </div>
        </div>
    )
}


export function Notification({title, type="default", timeOut=0,visible, onTimeOut, error=false, ...props}){
    
    if(!visible) return null
    
    const style = {}
    
    if(type ==="default"){
        style.backgroundColor = error ? "red" : "green"
        style.color = "white"
    }
    
    
    
    
    useEffect(() => {
        if(visible && timeOut > 0){
            const t = setTimeout(function(){
                typeof onTimeOut === "function" && onTimeOut()
            },timeOut)
            
            return () => clearTimeout(t)
            
        }
    }, [visible])
    
    
    return (
        <div className="ui-notification" style={style}>
            {title}
        </div>
    )
}
